import { graphql, useStaticQuery } from 'gatsby';
import { ProductVariants } from 'utils/types';

const useProductInfoMap = (productVariants: ProductVariants) => {
  const { allContentfulLandingPage } = useStaticQuery(graphql`
    query {
      allContentfulLandingPage {
        nodes {
          faqSchema {
            answer
            question
          }
          slug
          seoPage
          metaDescription
          contentToken {
            contentToken
          }
          landingPageContent {
            backgroundColor
            title
            subtitle {
              raw
            }
            image {
              gatsbyImageData(placeholder: BLURRED, quality: 100, width: 1147)
            }
            content {
              raw
            }
            recommendedProducts {
              measures
              title
              displayName
              slug
              description
              productId
              pdpImage {
                gatsbyImageData(placeholder: BLURRED, quality: 100)
              }
              markerList {
                markers {
                  title
                  description {
                    internal {
                      content
                    }
                  }
                }
              }
            }
            funFact {
              icon {
                gatsbyImageData(placeholder: BLURRED, quality: 100)
              }
              content {
                raw
              }
              linkUrl
              linkText
              medicalReviewer
              medicalReviewerLink
            }
          }
          trustCard {
            icon {
              gatsbyImageData(placeholder: BLURRED, quality: 100)
            }
            content {
              raw
            }
            medicalReviewer
            medicalReviewerLink
          }
          summary {
            summaryText
            returnText
            returnIcon {
              gatsbyImageData(placeholder: BLURRED, quality: 100)
            }
          }
        }
      }
    }
  `);

  const productInfoMap: { [index: number]: any } = {};
  allContentfulLandingPage.nodes.forEach((node: any) => {
    node?.landingPageContent?.forEach((section: any) => {
      const products = section.recommendedProducts;

      if (!products) return;

      products.forEach(async (product: any) => {
        const { productId } = product;
        const variant = productVariants[productId];
        productInfoMap[productId] = variant;
      });
    });
  });

  return { allContentfulLandingPage, productInfoMap };
};
export default useProductInfoMap;
